import { createBrowserHistory } from 'history';

export const router = createBrowserHistory();
